import InitVueApp from '@/entry';
import store from '@/apps/search/store';
import router from '@/apps/search/001/router';
import App from '@/apps/search/001/App';
import { appElement } from '@/apps/search/config';
import '@/plugins/vee-validate';
import '@/plugins/google-recaptcha';

new InitVueApp(App, appElement, { store, router });
